'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const Container = require('./../../../../core/container');
const Mediator = require('./../../../../core/mediator');

const designRepo = require('./../../repository/DesignRepository');
const themeManagement = require('./../themeManagement');

const zone = require('./../../../../services/structure/zone');
const fixHeight = require('./../../../../services/fixHeight');
const FormBuilder = require('./../../../../services/form');
const Notifier = require('./../../../../services/notifier');
const Loader = require('./../../../../services/loader');

const isColorDuplicate = function(colors) {
   let counts = [];
   let isDuplicate = false;

   colors.forEach((color)=> {
      if (counts.indexOf(color.color) === -1) {
         counts.push(color.color);
      } else {
         isDuplicate = true;
         Notifier.error(Translator.translate('duplicate_color_error', {'color': color.color}));
      }
   });

   return isDuplicate;
};

module.exports.onClick = function() {
   let $container = jQuery('<div class="color-panel"></div>');

   let $layer = zone.addLayer(Translator.translate('colors'), $container);

   Loader.start($layer);
   designRepo.getAllThemes().done(function(themes) {
      designRepo.getColorPanel().done(function(data) {
         let elements = {
            'primary_color': {
               'value': [data.primary],
               'label': Translator.translate(data.primary.id),
               'disabled': false,
               'isDeletable': false,
               'limit': 1,
               'type': 'colorPanelElement',
               'group': {
                  'id': 'basic-colors',
                  'renderType': 'twoColumns',
               },
            },
            'secondary_color': {
               'value': [data.secondary],
               'label': Translator.translate(data.secondary.id),
               'disabled': true,
               'isDeletable': false,
               'limit': 1,
               'type': 'colorPanelElement',
               'group': {
                  'id': 'basic-colors',
                  'renderType': 'twoColumns',
               },
            },
            'text_color': {
               'value': [data.textColor],
               'label': Translator.translate(data.textColor.id),
               'disabled': true,
               'isDeletable': false,
               'limit': 1,
               'type': 'colorPanelElement',
               'group': {
                  'id': 'basic-colors',
                  'renderType': 'twoColumns',
               },
            },
            'background_color': {
               'value': [data.backgroundColor],
               'label': Translator.translate(data.backgroundColor.id),
               'disabled': true,
               'isDeletable': false,
               'limit': 1,
               'type': 'colorPanelElement',
               'group': {
                  'id': 'basic-colors',
                  'renderType': 'twoColumns',
               },
            },
            'custom_colors': {
               'value': data.customColors,
               'disabled': false,
               'isDeletable': true,
               'limit': data.customColors.length,
               'type': 'colorPanelElement',
               'addColor': true,
            },
         };

         let form = FormBuilder.getForm({
            'elements': elements,
            'form': {
               'submit_class': 'd-none',
            },
         });

         $container.append(form.render());
         Loader.stop($layer);

         form.on('submit', (data) => {
            if (!isColorDuplicate(data.custom_colors)) {
               let colors = {
                  'primary': data.primary_color[0].color,
                  'custom_colors': data.custom_colors,
               };

               zone.hidePanels(Container.get('$smallPanel'));
               designRepo.updateColorPanel(colors).done(function() {
                  Notifier.success(Translator.translate('parameters_saved'));
                  location.reload();
               });
            }
         });

         let $themesLink = '';

         if (themes.length > 1) {
            $themesLink = '<a class="themes-link font-weight-bold float-right cursor-pointer" title="change theme">'+ Translator.translate('change_theme') +'</a>';
         }

         $container.find('form').prepend('<label class="cloud-label label-color-panel">'+ Translator.translate('colors_theme') + $themesLink +'</label>');

         $container.find('.themes-link').on('click', function() {
            themeManagement.onClick();
         });

         zone.setFooter($layer, zone.createSubmitButtons({
            onSubmitClick: form.submit.bind(form),
         }));

         fixHeight.fix($container, jQuery(window).height() - 165);
      });
   });
};

module.exports.afterSubmit = function() {
   let $toolBar = Container.get('$toolbar');
   let $moreParametersBtn = $toolBar.find('.icon-more-parameters');

   $moreParametersBtn.parent().addClass('btn-focus');
   Mediator.publish('menu:more-parameters:click');
   Mediator.publish('menu:more-parameters:design_settings:click');
   Mediator.publish('menu:design_settings:color_settings:click');
};
